import styled from "styled-components";
import { pxToRem } from "../../styles/utils";


export const CalendarContainer = styled.div`
  width: ${pxToRem(500)};

  .react-datepicker {
    border: none;
    border-radius: ${pxToRem(12)}; /* Было 16px */
    background-color: white;
    font-family: 'Arial', sans-serif;
    font-size: ${pxToRem(14)};
    box-shadow: 0px ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.1);

    /* Шапка */
    .react-datepicker__header {
      background-color: white;
      color: #333;
      border-bottom: none;
      border-top-left-radius: ${pxToRem(12)}; /* Было 16px */
      border-top-right-radius: ${pxToRem(12)}; /* Было 16px */
      text-align: center;
    }

    .react-datepicker__current-month {
      font-weight: bold;
      font-size: ${pxToRem(16)};
      color: #333;
    }

    .react-datepicker__month-container {
      padding: ${pxToRem(16)};
    }


    /* Базовые стили для различных "выделенных" состояний */
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__day--range-start,
    .react-datepicker__day--range-end,
    .react-datepicker__day--selecting-range-end,
    .react-datepicker__day--selected,
    .react-datepicker__day--today {
      background: rgba(114, 82, 220, 0.19);
      color: rgb(114, 82, 220) !important;
    }

    /* Наведение */
    .react-datepicker__day:hover {
      background: rgba(114, 82, 220, 0.19);
      color: rgb(114, 82, 220) !important;
      border-radius: ${pxToRem(12)};
    }

    /* Для непрерывного фона — убираем радиусы у дней внутри диапазона */
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range {
      border-radius: 0 !important;
    }

    /* Скругление у начала / конца диапазона */
    .react-datepicker__day--range-start {
      border-radius: ${pxToRem(12)} 0 0 ${pxToRem(12)} !important;
    }
    .react-datepicker__day--range-end,
    .react-datepicker__day--selecting-range-end {
      border-radius: 0 ${pxToRem(12)} ${pxToRem(12)} 0 !important;
    }

    /* Выбранный день (если не диапазон, а одиночная дата) */
    .react-datepicker__day--selected {
      border-radius: ${pxToRem(12)} 0 0 ${pxToRem(12)} !important;
    }

    /* Первый и последний день в selecting-range */
    .react-datepicker__day--in-selecting-range:first-child {
      border-radius: ${pxToRem(12)} 0 0 ${pxToRem(12)} !important; /* Было 16px */
    }
    .react-datepicker__day--in-selecting-range:last-child {
      border-radius: 0 ${pxToRem(12)} ${pxToRem(12)} 0 !important; /* Было 16px */
    }

    /* "Сегодня" */
    .react-datepicker__day--today {
      border-radius: ${pxToRem(12)};
    }

    /* Общие стили для day-name / day / time-name */
    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      color: rgb(225, 225, 225);
      margin-right: 0;
      margin-left: 0;
      font-weight: 700;
      font-size: ${pxToRem(14)};

      &:last-child {
        padding-right: 0;
      }
      &:first-child {
        padding-left: 0;
      }
    }

    /* Уточнение цвета для названий дней */
    .react-datepicker__day-name {
      color: rgb(165, 165, 165);
      margin-left: ${pxToRem(1)};
    }

    /* Стрелочки переключения */
    .react-datepicker__navigation {
      color: #000000;
      position: absolute;
      top: 12%;
      transform: translateY(-50%);
      width: ${pxToRem(40)};
      height: ${pxToRem(40)};
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      z-index: 1;
    }

    [class^="react-datepicker__day"] {
      width: ${pxToRem(25)};
      height: ${pxToRem(25)};
      padding-top: ${pxToRem(4)};
    }

    .react-datepicker__day-names {
      margin-bottom: ${pxToRem(5)};
      margin-top: ${pxToRem(10)};
    }

    .react-datepicker__navigation-icon::before {
    margin-top: ${pxToRem(6)};
    }

  }
`;
